import { IAccordionClasses } from "./Accordion";

export default <IAccordionClasses>{
  base: "!transition duration-1000 ease-in-out",
  accordionItem: "relative my-6",
  accordionHeader: "w-full py-3 cursor-pointer text-primary",
  accordionTrigger: "group inline-flex w-full items-start justify-between",
  accordionArrow: "text-2xl text-txt-primary",
  accordionContent: "",
};
